function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './checkbox.scss';
import template from './checkbox.html';

export var CheckboxComponent = {
  template: template,
  styles: styles,
  require: {
    model: "ngModel" },

  bindings: {},
  controller: /*#__PURE__*/function () {
    function CheckboxComponentController() {
      "ngInject";_classCallCheck(this, CheckboxComponentController);
      console.log(this);
    }_createClass(CheckboxComponentController, [{ key: "onChange", value: function onChange()

      {
        this.model.$setViewValue(this.value);
      } }, { key: "$onInit", value: function $onInit()

      {var _this = this;
        this.model.$render = function () {
          _this.value = _this.model.$viewValue;
        };
      } }]);return CheckboxComponentController;}() };